(function () {
  function updateCartItemCompareTotals() {
    document.querySelectorAll('.cart-item').forEach((item) => {
      const qtyInput = item.querySelector('.qty-input__input');
      const comparePrice = item.querySelector('.cart-item__total .price__was');

      if (!comparePrice) return;

      const qty = qtyInput ? parseInt(qtyInput.value, 10) || 0 : 0;

      if (qty >= 2) {
        item.classList.add('is-multi-qty');
      } else {
        item.classList.remove('is-multi-qty');
      }
    });
  }

  document.addEventListener('DOMContentLoaded', updateCartItemCompareTotals);

  document.addEventListener('change', function (e) {
    if (e.target.matches('.qty-input__input')) {
      updateCartItemCompareTotals();
    }
  });

  document.addEventListener('input', function (e) {
    if (e.target.matches('.qty-input__input')) {
      updateCartItemCompareTotals();
    }
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest('.qty-input__btn')) {
      setTimeout(updateCartItemCompareTotals, 50);
    }
  });

  document.addEventListener('cart:updated', updateCartItemCompareTotals);

  const observer = new MutationObserver(() => {
    updateCartItemCompareTotals();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();